

const pages = {
    show: "Visualizar",
    alterStatus: "Reativar ou Inativar",
    edit: "Editar",
    create: "Cadastrar",
    list: null,
    notFound: null
}

const login = {
    currentCategory: "",
    entity: "",
    href: ""
}

const dashboard = {
    currentCategory: "Dashboard",
    entity: "",
    href: "dashboard"
}
const servicoAcolhimento = {
    currentCategory: "Serviços de Acolhimento",
    entity: "",
    href: "servico-acolhimento"
}

const crianca = {
    currentCategory: "Crianças e Adolescentes",
    entity: "",
    href: "crianca"
}

const motivoSituacao = {
    currentCategory: "Cadastros",
    entity: "Motivo de Situação",
    href: "motivo-situacao"
}

const tipoServicoAcolhimento = {
    currentCategory: "Cadastros",
    entity: "Tipo de Serviço de Acolhimento",
    href: "tipo-servico-acolhimento"
}

const doenca = {
    currentCategory: "Cadastros",
    entity: "Doenças",
    href: "doenca"
}

const situacaoJuridica = {
    currentCategory: "Cadastros",
    entity: "Situação Jurídica",
    href: "situacao-juridica"
}

const visitas = {
    currentCategory: "Visita",
    entity: "",
    href: "visitas/lista"
}
const notFound = {
    currentCategory: "Página não encontrada",
    entity: "",
    href: ""
}

function selectPage(entity, page) {

    if (!isNaN(parseInt(page))) {
        entity["page"] = pages.show;

    } else if (page === "lista") {
        entity["page"] = pages.list;
    }
    else if (page === "alterar-vigencia") {
        entity["page"] = pages.alterStatus;
    }
    else if (page === "cadastrar") {
        entity["page"] = pages.create;
    }
    else if (page === "editar") {
        entity["page"] = pages.edit;
    }
    else if (page !== undefined) {
        if (page.includes("-")) {
            let temp = page.split("-").map((name) => name[0].toUpperCase() + name.substring(1)).join(" ");
            entity["page"] = temp;
        }
    }
    else {
        entity["page"] = pages.notFound;
    }
    return entity;
}

export function checkEntity(entity, page) {

    if (entity === "" || undefined) {
        return selectPage(login, page);
    } else if (entity === "tipo-servico-acolhimento") {
        return selectPage(tipoServicoAcolhimento, page);
    } else if (entity === "dashboard") {
        return selectPage(dashboard, page);
    }
    else if (entity === "doenca") {
        return selectPage(doenca, page);
    }
    else if (entity === "situacao-juridica") {
        return selectPage(situacaoJuridica, page);
    }
    else if (entity === "motivo-situacao") {
        return selectPage(motivoSituacao, page);
    }
    else if (entity === "servico-acolhimento") {
        return selectPage(servicoAcolhimento, page);
    } else if (entity === "visitas") {
        return selectPage(visitas, page);
    } else if (entity === "crianca") {
        return selectPage(crianca, page);
    } else {
        return selectPage(notFound, page)
    }

}